import * as noticesOfDepartureReducer from "../reducers/noticeOfDepartureReducer";

export const { getNoticesOfDeparture, getNoticeOfDeparture } = noticesOfDepartureReducer;
